/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import GameSetup from '../../../Game/GameSetup';
import { ISettings } from '../../../Server/SetupResult';
import CLog, { LogTypes } from '../../ComponentLogger';
import Decorators from '../../Decorators';
import { getProperty } from '../../Misc';
import InjectableComponent from '../ComponentReference/InjectableComponent';
import ObservableStringComponent from './ObservableStringComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Provides an observer pattern for configuration data. */
@cc._decorator.ccclass
export default class ObservableConfigurationComponent extends ObservableStringComponent
{
    /** @hidden */
    protected _gameSetupRef: InjectableComponent<GameSetup> = new InjectableComponent<GameSetup>();

    /** The name of the configuration entry. */
    @property({ visible: true })
    private _key: string = "configKey";

    /** @hidden */
    protected setContexts(): void
    {
        super.setContexts();
        this._gameSetupRef.SetContext(GameSetup);
    }

    /** @hidden */
    protected start(): void
    {
        super.start();
        this._gameSetupRef.WithValue(gameSetup => gameSetup.OnSetupReceived(this.onSetup));
    }

    /** @hidden */
    protected onDestroy(): void
    {
        this._gameSetupRef.WithValue(gameSetup => gameSetup.OffSetupReceived(this.onSetup));
        super.onDestroy();
    }

    /** On setup, store the sought value from the configuration, notifying observers */
    @Decorators.BindThis()
    private onSetup(): void
    {
        let settings: ISettings = this._gameSetupRef.Value.Settings;
        let configValue: string = getProperty(settings, this._key);
        if (configValue == null)
        {
            CLog.warn("Observing missing config value: " + this._key, LogTypes.Configuration);
        }
        else
        {
            this.Value = configValue;
        }
    }
}
